const content = {
  Owner: {
    header: 'How would you like us to send you details of your cover?',
    footer: '',
    communication_types: {
      post: 'Post',
      email: 'Email',
      sms: 'SMS',
    },
  },
  Broker: {
    header:
      'Once you have issued the policy,&nbsp;you can send confirmation to your client via the Policy Details screen.\n\n' +
      'Policy Documents can be accessed within the Documents tab for download.',
    footer: '',
    communication_types: {
      sms:
        'Do you want to send basic details by SMS?\n\n' +
        '###### This will include the policy number and medical assistance number. ',
    },
  },
  // Broker: {
  //   header:
  //     'You can send the documents to the client by email and send a confirmation text.\n\n' +
  //     'Just tick the boxes below.',
  //   footer:
  //     'If you’d prefer to simply print the docs just proceed without ticking the box above.',
  //   communication_types: {
  //     email:
  //       'Do you want to email the docs to your client?\n\n\n\n' +
  //       '###### NB if you tick this your client will receive a link to activate an online account where they can download documents. They can then login at anytime from anywhere and access/print docs.',
  //     sms:
  //       'Do you want to send basic details by SMS?\n\n\n\n' +
  //       '###### This will include the policy number and medical assistance number. ',
  //   },
  // },
};

export default function getCommunicationOptionsContent(type) {
  return content[type];
}
